<template>
  <photo-album :is-squared="true" tagging="" :actions="actions">
    <slide v-for="(product, i) in initialdata" :key="i" class="photo-album-slide">
      <div class="photo-album-slide--photo media-item media-item--image-responsive">
        <img class="" :src="product.product_image" :alt="product.product_name" />
      </div>
      <div class="row">
        <div class="col-sm-8 col-sm-push-2">
          <h3 class="photo-album-slide--title">{{ product.product_name }}</h3>
          <p>{{ product.product_summary }}</p>
          <a
            v-if="product.purchase_button_link"
            class="product-button shop-now-new-btn"
            :href="product.purchase_button_link"
          >
            {{ product.purchase_button_text }}</a
          >
        </div>
      </div>
    </slide>
  </photo-album>
</template>
<script>
export default {
  name: 'product-carousel',
  props: {
    initialdata: { type: Array, required: true },
  },
  data() {
    return {
      actions: {
        next: 'next',
        previous: 'previous',
        select: 'display',
      },
    };
  },
};
</script>
